import React from "react";
import { Button, Dialog, Checkbox, Radio, Divider } from "@material-ui/core";
import QRCode from "react-qr-code";
import PrintComponents from "react-print-components";
import ticketFooter from "../../../../ebusHomePics/ticket-footer.png";
import tickzz from "../../../../ebusHomePics/tickzz.png";
import { getUserTravelInfo, setExtradition } from "../CrudAndRedux/ProfileCrud";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../CrudAndRedux/ProfileRedux";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { DateTimeHandler } from "./../../../utils/Helper";
// import ReactPDF from '@react-pdf/renderer';
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const PageBottomButton = (props) => {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [checked, setChecked] = React.useState(false);
  const [step, setStep] = React.useState("information");
  const [paymentMethod, setPaymentMethod] = React.useState("wallet");

  const dispatch = useDispatch();
  let { state } = useSelector((state) => ({
    state: state.auth,
  }));

  const history = useHistory()

  const dialogSituationSetter = () => {
    if (step === "information") {
      return (
        <>
          <div style={{ marginTop: "1.3rem" }} className="d-flex flex-wrap">
            <h5
              className="col-12 col-md-6 pb-9 mt-2 mb-5 d-flex"
              style={{ borderBottom: "1px solid lightgray", gap: "10px" }}
            >
              <span>شماره بلیط:</span>
              <b>
                {
                  props.data?.id
                }
              </b>
            </h5>
            <h5
              className="col-12 col-md-6 pb-9 mt-2 mb-5 d-flex"
              style={{ borderBottom: "1px solid lightgray", gap: "10px" }}
            >
              <span>ساعت حرکت:</span>{" "}
              <b>
                {
                  DateTimeHandler(props.data?.Travel.departureDatetime).time
                }
              </b>
            </h5>
            <h5
              className="col-12 col-md-6 pb-9 mt-2 mb-5 d-flex"
              style={{ borderBottom: "1px solid lightgray", gap: "10px" }}
            >
              <span> مبدا: </span>
              <b>
                {" "}
                {props.data?.ticketSource.title
                  ? `ترمینال ${props.data?.ticketSource.title}`
                  : "دریافت نشد"}
              </b>
            </h5>
            <h5
              className="col-12 col-md-6 pb-9 mt-2 mb-5 d-flex"
              style={{ borderBottom: "1px solid lightgray", gap: "10px" }}
            >
              <span>مقصد:</span>
              <b>
                {" "}
                {props.data?.ticketDest.title
                  ? `ترمینال ${props.data?.ticketDest.title}`
                  : "دریافت نشد"}
              </b>
            </h5>
          </div>
          <div
            className="d-block d-md-flex justify-content-between"
            style={{ alignItems: "flex-end" }}
          >
            <div
              className="d-flex flex-wrap mt-3 mb-8 align-items-baseline"
              style={{ gap: "8px" }}
            >
              <Checkbox
                checked={checked}
                onChange={(e) => setChecked(!checked)}
                style={{ color: "black", transform: "scale(1.35)", }}
                className="p-0"
              />
              <h5 className="my-auto">
                <a style={{ textDecoration: "underline" }}>قوانین استرداد</a> را
                مطالعه کرده ام
              </h5>
            </div>
            <h3 className="mx-auto my-8">
              مبلغ قابل استرداد:{" "}
              <span style={{ color: "#6dd06d" }}>
                <b>{props.data.orginalPrice.toLocaleString('ar-EG')} ریال</b>
              </span>
            </h3>
          </div>
        </>
      );
    } else if (step === "PaymentMethod") {
      return (
        <div style={{ marginTop: "1.3rem" }} className="d-flex flex-column">
          <div className="d-flex" style={{ gap: "10px" }}>
            <Radio
              checked={paymentMethod === "wallet"}
              value="wallet"
              className="p-0 align-self-baseline"
              onChange={() => {
                setPaymentMethod("wallet");
              }}
              style={{ color: "#6dd06d", transform: "scale(1.35)" }}
            />
            <div className="d-flex flex-column" style={{ gap: "10px" }}>
              <h4>
                <b>واریز به کیف پول ایباس</b>
              </h4>
              <h6>مبلغ مورد نظر در کیف پول اکانت ایباس شما شارژ میشود</h6>
            </div>
          </div>
          <Divider className="w-100" style={{ marginBlock: "2rem" }} />
          <div className="d-flex" style={{ gap: "10px" }}>
            <Radio
              checked={paymentMethod === "card"}
              value="card"
              className="p-0 align-self-baseline"
              onChange={() => {
                setPaymentMethod("card");
              }}
              style={{ color: "#6dd06d", transform: "scale(1.35)" }}
            />
            <div className="d-flex flex-column" style={{ gap: "10px" }}>
              <h4>
                <b>واریز به حساب بانکی</b>
              </h4>
              <h6>
                مبلغ مورد نظر به حسابی که بلیط را با ان خریداری کرده اید واریز
                میشود
              </h6>
            </div>
          </div>
        </div>
      );
    } else if (step === "result") {
      return (
        <div style={{ marginTop: "1.3rem" }} className="container">
          <div style={{ height: "8rem" }} className="col-12">
            <img
              src={tickzz}
              className="h-100 w-100"
              style={{ objectFit: "contain" }}
            />
          </div>
          <h4 className="d-flex" style={{ marginBlock: "2rem" }}>
            <b className="mx-auto">درخواست شما با موفقیت ثبت شد</b>
          </h4>
          <h6 style={{ lineHeight: "20px" }}>
            مبلغ استرداد حداکثر تا ۷۲ ساعت آینده به حساب شما واریز میشود در صورت
            بروز هرگونه مشکل با پشتیبانی ایباس تماس بگیرید
          </h6>
          <div
            style={{ height: "4rem", marginTop: "2rem" }}
            className="p-1 d-flex"
          >
            <Button
              className="h-100 w-75 mx-auto"
              style={{ backgroundColor: "lightgray", borderRadius: "13px" }}
              onClick={() => {
                setDialogOpen(false);
              }}
            >
              <h6 className="my-auto">بستن</h6>
            </Button>
          </div>
        </div>
      );
    }
  };

  const handleDownloadPdf = async () => {
    const canvas = await html2canvas(document.querySelector('#pdf'));
    const data = canvas.toDataURL('image/png');

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight =
      (imgProperties.height * pdfWidth) / imgProperties.width;

    pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save('print.pdf');
  };
  
  return (
    <div
      className="d-md-flex d-block  container-fluid  mx-auto  mb-3 text-right"
      style={{ justifyContent: "flex-start", gap: 10, marginTop: "8%" }}
    >
      <PrintComponents
        trigger={
          <Button
            variant="outlined"
            className="col-12 col-md-4 w-100 my-2 bg-white"
            style={{
              border: "2px solid #6dd06d",
              borderRadius: 13,
              height: "4rem",
            }}
          >
            <h6 className="my-auto" style={{ color: "#6dd06d" }}>
              <b>چاپ بلیط</b>
            </h6>
          </Button>
        }
      >
        <div
          className="mx-auto w-75 border border-dark px-7"
          style={{ height: "20cm", width: "15cm" }}
        >
          <div
            className="row justify-content-between"
            style={{ marginInline: "25px", marginBlock: "3rem 1.5rem" }}
          >
            <h1>
              {" "}
              <b>مبدا:</b> {props.data?.ticketSource.title}
            </h1>
            <h1>
              {" "}
              <b>مقصد:</b>
              {props.data?.ticketDest.title}
            </h1>
          </div>
          <div
            className="line w-100"
            style={{
              borderBottom: "4px solid black",
              marginBlock: "2rem",
            }}
          ></div>
          <div
            className="row justify-content-between my-5 "
            style={{ marginInline: "25px", marginBlock: "3rem 1.5rem" }}
          >
            <h1>
              <b>تاریخ:</b>
              <span style={{ marginRight: 5 }}>
                {
                  DateTimeHandler(props.data?.Travel.departureDatetime).date
                }
              </span>
            </h1>
            <h1>
              <b>ساعت حرکت:</b>
              <span style={{ marginRight: 5 }}>
                {
                  DateTimeHandler(props.data?.Travel.departureDatetime).time
                }
              </span>
            </h1>
          </div>
          <div
            className="line w-100"
            style={{
              borderBottom: "4px solid black",
              marginBlock: "2rem",
            }}
          ></div>

          <div
            className="row mb-5"
            style={{ marginRight: "25px", marginLeft: "12px" }}
          >

            <div className="col-md-6 row d-lg-flex mt-1 justify-content-between">
              <div
                className="col-md-12 mt-3 mt-lg-0"
                style={{ fontSize: "23px" }}>
                <span >
                  <b>شماره سفارش: </b>
                </span>
                <span
                  className="white-nowrap"
                  style={{
                    whiteSpace: "nowrap",
                  }}
                >
                  {props.data?.id ? props.data?.id : null}
                </span>
              </div>

              <div
                className="col-md-12 mt-3 mt-lg-0"
                style={{ fontSize: "22px" }}>
                <span >
                  <b>نام مسافر/مسافرین: </b>
                </span>
                <span
                  className="white-nowrap"
                  style={{
                    whiteSpace: "nowrap",
                  }}
                >
                  {props.data?.TravelTicketDetails ?
                    props.data?.TravelTicketDetails.map((ticket, index) =>
                    (
                      `${ticket.passengerFirstName} ${" "} ${ticket.passengerLastName} 
                       ${index === props.data.TravelTicketDetails.length - 1 ? " " : " , "}
                      `
                    ))
                    : null}
                </span>
              </div>

              <div
                className="col-md-12 mt-3 mt-lg-0"
                style={{ fontSize: "23px" }}>
                <span>
                  <b>شماره صندلی: </b>
                </span>
                <span
                  className=" white-nowrap"
                  style={{
                    whiteSpace: "nowrap",
                  }}
                >
                  {props.data?.TravelTicketDetails ?
                    props.data?.TravelTicketDetails.map((ticket, index) =>
                    (
                      `${ticket.seatNumber} 
                       ${index === props.data.TravelTicketDetails.length - 1 ? " " : " , "}
                      `
                    ))
                    : null}
                </span>
              </div>

              <div
                className="col-md-12 mt-3 mt-lg-0"
                style={{ fontSize: "23px" }}>
                <span>
                  <b>قیمت: </b>
                </span>
                <span
                  className="white-nowrap"
                  style={{
                    whiteSpace: "nowrap",
                    textDecoration: "line-through"
                  }}
                >
                  {props.data.Travel ? props.data.Travel.basePrice.toLocaleString('ar-EG') : null}
                </span>
                <span> - </span>
                <span
                  className=" white-nowrap"
                  style={{
                    whiteSpace: "nowrap",
                  }}
                >
                  {props.data ? props.data?.orginalPrice.toLocaleString('ar-EG') : null}
                </span>
              </div>
            </div>

            <div className="col-6 w-100" style={{ paddingBlock: "2rem" }}>
              {props.data.qrCode ? (
                <QRCode
                  value={props.data.qrCode}
                  className="w-100"
                  style={{ height: "5rem" }}
                />
              ) : null}
            </div>
          </div>
          <img src={ticketFooter} className="w-100" />
        </div>
      </PrintComponents>
      {/* <Button
        variant="outlined"
        className="col-12 col-md-4  my-2 bg-white"
        style={{
          border: "2px solid  #8585cf",
          borderRadius: 13,
          height: "4rem",
        }}
        onClick={() => {
          CompleteTicketDetail();
        }}
      >
        <Link to="">
          <h6 className="my-auto" style={{ color: " #8585cf" }}>
            <b>تکمیل مشخصات</b>
          </h6>
        </Link>
      </Button> */}
      {/* <Button
        variant="outlined"
        className="col-12 col-md-4 w-100 my-2 bg-white"
        style={{
          border: "2px solid #8585cf",
          borderRadius: 13,
          height: "4rem",
        }}
        onClick={handleDownloadPdf}
      >
        <h6 className="my-auto" style={{ color: " #8585cf" }}>
          <b>دانلود بلیط</b>
        </h6>
      </Button> */}
      <Button
        variant="outlined"
        className="col-12 col-md-4  my-2 bg-white"
        style={{
          border: "2px solid #f9ce7f",
          borderRadius: 13,
          height: "4rem",
        }}
        onClick={() => {
          setDialogOpen(true);
        }}
      >
        <h6 className="my-auto" style={{ color: "#f9ce7f" }}>
          <b>استرداد</b>
        </h6>
      </Button>
      <Dialog
        PaperProps={{
          style: {
            width: "75rem",
          },
        }}
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
      >
        <div className="d-flex flex-column p-7 py-11">
          <h1>
            <b>استرداد</b>
          </h1>
          <h3
            className={`col-6 col-md-4 pb-3 ${step === "result" ? "d-none" : "d-block"
              }`}
            style={{
              borderBottom: "2.8px solid #6dd06d",
              marginTop: "1.7rem",
              whiteSpace: "nowrap",
            }}
          >
            {step === "PaymentMethod" ? "نحوه واریز" : "مشخصات بلیط"}
          </h3>
          {dialogSituationSetter()}
          <div
            className={` flex-wrap justify-content-between ${step === "result" ? "d-none" : "d-flex"
              }`}
            style={{ marginTop: "2rem" }}
          >
            <div
              style={{
                height: "4rem",
                cursor: checked ? "pointer" : "not-allowed",
              }}
              className="col-12 col-md-6 my-2 p-1"
            >
              {checked ? (
                <Button
                  className="h-100"
                  fullWidth
                  style={{ backgroundColor: "#6dd06d", borderRadius: "13px" }}
                  onClick={() => {
                    const data = {
                      travelTicketId: props.data?.travelTicketId,
                      phone: state.user.user.phone,
                    };
                    setExtradition(data, state.user.token).then((res) => {
                      {
                        getUserTravelInfo(state.user.token)
                          .then((res) => {
                            dispatch(actions.getUserHistory(res.data));
                            dispatch(actions.setMockedData(res.data));
                          })
                          .catch(() => {
                            toast("مشکلی در ارتباط با سرور بوجود آمد");
                          });
                        setStep("result");
                      }
                    });
                  }}
                >
                  <h6 className="my-auto text-white">استرداد</h6>
                </Button>
              ) : (
                <Button
                  className="h-100"
                  fullWidth
                  style={{ backgroundColor: "#6dd06d", borderRadius: "13px" }}
                  disabled
                >
                  <h6 className="my-auto text-white">استرداد</h6>
                </Button>
              )}
            </div>
            <div
              style={{ height: "4rem" }}
              className="col-12 col-md-6 my-2 p-1"
            >
              <Button
                className="h-100"
                fullWidth
                style={{ backgroundColor: "lightgray", borderRadius: "13px" }}
                onClick={() => {
                  setDialogOpen(false);
                }}
              >
                <h6 className="my-auto text-white">انصراف</h6>
              </Button>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default PageBottomButton;
